/**
 * @deprecated - no longer needed
 */
export const initialCartId = 'new'

export const uninitializedCart: Transformed.Cart = {
  appliedPerks: { freeTickets: [] },
  cartMod: [],
  expiresAt: null,
  expiresIn: null,
  feesTotal: 0,
  giftCards: [],
  grandTotal: 0,
  lineItemsTotal: 0,
  purchaser: {
    email: '',
    firstName: '',
    lastName: '',
    country: null,
    id: '',
    identityId: '',
    phoneNumber: '',
    zipCode: '',
  },
  sellerId: null,
  state: 'NEW',
  subTotal: 0,
  taxesTotal: 0,
  ticketCount: 0,
  id: initialCartId,
  lineItems: [],
}
